<!-- 报告库预警 列表 sqm 
  components: { hButton },-->
<template>
  <h-list-page class="rohsReportWarnLibraryList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('0877751ad0ca9072aad13edca6d986d1')">
          <h-input v-model="searchData.testReportNumber" clearable @change="changeNull(searchData.testReportNumber, 'testReportNumber')">
          </h-input>
        </h-search>
        <h-search :title="h_i18n('4e20e078c1d3a0805446e70bd8b4400b')">
          <h-select v-model="searchData.testDepartment" clearable filterable @change="changeNull(searchData.testDepartment, 'testDepartment')">
            <h-option v-for="item in data.testDepartmentList" :label="item.value" :value="item.value" :key="item.value"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('231a2e1471eb62cac39fc761ac0d0761')">
          <h-input v-model="searchData.belongTo" clearable @change="changeNull(searchData.belongTo, 'belongTo')">
          </h-input>
        </h-search>
        <h-search :title="h_i18n('f66233940b0acfaf83a1825cf714eb55')">
          <h-select v-model="searchData.isEffect" clearable filterable @change="changeNull(searchData.isEffect, 'isEffect')">
            <h-option :label="h_i18n('1abbb1748ef98f00486f7801a290fdb4')" value="0"></h-option>
            <h-option :label="h_i18n('c6cc397661432878e10a24834460da0d')" value="1"></h-option>
            <h-option :label="h_i18n('c4a4d9f768737d3d24002eed65a3cbed')" value="2"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('1de8349a0ae081c3b8c4d4a1951e8562')">
            <h-date-picker @change="TimeChange(searchData.submitTime, {start:'beginDateOne',end:'endDateOne'})" v-model="searchData.submitTime"
              type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
          </h-search>
        
          <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getWarnInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('3e269bfd5b2d084877f3cf2566229e07')" :is-left="0" :is-right="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <h-button type="primary" :loading="data.exportLoading" @click="excleBtn">
            <export />{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            <!-- <h-button type="primary" :loading="data.exportLoading" @click="backOldVersion">
            <history />
          切换旧版</h-button> -->
          <div class="dangerColor" style="display: flex;align-items: center;margin-left: 20px;font-size: 12px">{{ h_i18n('84a84c2d77921398d7f159f5c69ecba1') }}</div>
        </h-button-group>
        <!-- <div style="display: flex;align-items: center;margin-left: 20px;color: red;font-size: 16px">默认导出本月的数据。</div> -->
      </template>
      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" @selection-change="handleSelectionChange" border :data="data.dataOfTable" size="small" height="540" style="width: 100%;min-height:540px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="belongTo" :label="h_i18n('231a2e1471eb62cac39fc761ac0d0761')" min-width="150"></el-table-column>
        <el-table-column prop="testDepartment" :label="h_i18n('4e20e078c1d3a0805446e70bd8b4400b')" min-width="150"></el-table-column>
        <el-table-column prop="testReportNumber" :label="h_i18n('0877751ad0ca9072aad13edca6d986d1')" min-width="150"></el-table-column>
        <el-table-column prop="reportDate" :label="h_i18n('75cd7f22e38d44007e8ccacf06715b85')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.reportDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expriryTime" :label="h_i18n('6460f46b3607ac4b78225902f085048d')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.expriryTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isEffect" :label="h_i18n('57268209c5832c81556ae8d368a7d2cf')" min-width="70">
          <template #default="{ row }">
            <span v-if="row.isEffect == '0'">{{ h_i18n('1abbb1748ef98f00486f7801a290fdb4') }}</span>
            <span v-if="row.isEffect == '1'">{{ h_i18n('c6cc397661432878e10a24834460da0d') }}</span>
            <span v-if="row.isEffect == '2'">{{ h_i18n('c4a4d9f768737d3d24002eed65a3cbed') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="testReportNumberOld" :label="h_i18n('3f12324c202cef331d8603466afff54c')" min-width="100"></el-table-column>
        <el-table-column prop="submitPerson" :label="h_i18n('e080329c020dc42739b9c0a043845712')" min-width="90"></el-table-column>
        <el-table-column prop="submitTime" :label="h_i18n('fb4cc0f776e82afd9c2b6ca157ddc639')" min-width="170"></el-table-column>
        <el-table-column prop="updateTime" :label="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" min-width="170">
          <template #default="{ row }">
            <span>{{ time(row.updateTime,6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')">
          <template #default="{ row }">
            <h-file v-if="row.fileUuid && row.fileName" :name="row.fileName" :delete-type="false" :url="row.fileUuid" @delete="deleteFun"
             :autoOpen='false' @open="openFile(row.fileUuid,row.fileName)"></h-file>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" min-width="80" class-name="table_button_style">
          <template #default="{ row }">
            <h-button type="primary" v-if="data.roleCode=='S009'" @click="upDateBtn(row)">{{ h_i18n('32ac152be1911e9360047dcb0898cf70') }}</h-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="getWarnInfo()"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>

    </h-table-card>
  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
import hButton from "../../../views/Templates/h-button.vue";
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()
  const searchData = reactive({
    pageNo: 1,
    pageSize: 10,
  })
  const data = reactive({
    keepalivestatus:0,
    exportLoading:false,
    tableLoading:false,
    dataOfTable:[],
    testDepartmentList:[
      { value : "通标标准技术服务（天津）有限公司" } ,
      { value : "通标标准技术服务（青岛）有限公司" } ,
      { value : "通标标准技术服务（宁波）有限公司"} ,
      { value : "通标标准技术服务有限公司宁波分公司"} ,
      { value : "通标标准技术服务（上海）有限公司" } ,
      { value : "通标标准技术服务有限公司广州分公司" } ,
      { value : "天津津滨华测产品检测中心有限公司" } ,
      { value : "上海华测品标检测技术有限公司" } ,
      { value : "华测检测认证集团股份有限公司" } ,
      { value : "宁波市华测检测技术有限公司" } ,
      { value : "苏州市华测检测技术有限公司" } ,
      { value : "谱尼测试集团股份有限公司" } ,
      { value : "谱尼测试集团深圳有限公司" } ,
      { value : "青岛谱尼测试有限公司" } ,
      { value : "必维申美商品检测（上海）有限公司" } ,
      { value : "广州广电计量检测股份有限公司" } ,
      { value : "广州广电计量检测无锡有限公司" } ,
      { value : "广电计量检测（无锡）有限公司" } ,
      { value : "广电计量检测集团股份有限公司" } ,
      { value : "威凯检测技术有限公司"} ,
      { value : "中家院（北京）检测认证有限公司"} ,
      { value : "苏州市信测标准技术服务有限公司"} ,
      { value : "东莞市信测科技有限公司"} ,
      { value : "上海出入境检验检疫局机电产品检测技术中心"} ,
      { value : "浙江省检验检疫科学技术研究院"} ,
      { value : "南德认证检测（中国）有限公司深圳分公司"} ,
      { value : "佛山市沃特测试技术服务有限公司" } ,
      { value : "斯坦德检测集团股份有限公司" } ,
      { value : "杭州希科检测技术有限公司" } ,
      { value : "南德认证检测（中国）有限公司上海分公司" } ,
      { value : "广州信测标准技术服务有限公司" } ,
      { value : "天津华测检测认证有限公司" } ,
      { value : "东莞市北测标准技术服务有限公司" } ,
      { value : "国高材高分子材料产业创新中心有限公司" } ,
      { value : "上海天祥质量技术服务有限公司" } ,
      { value : "莱茵技术-商检（青岛）有限公司" } ,
    ],
  })
// 切换旧版
const backOldVersion = () =>{
  if (process.env.NODE_ENV != 'production') {
    window.open(`http://sqm-test.qd-huangdao-test.haier.net/newproduct/rohs_report_warn_index?resourceId=7&roleCode=${data.roleCode}&vCode=${data.supplyCode}&supplyCode=${data.supplyCode}&trueName=${data.trueName}&supplyName=${data.supplyName}&userName=${data.userName}&dataFrom=sqm`)
  }else{
    window.open(`https://sqm.haier.net/newproduct/rohs_report_warn_index?resourceId=7&roleCode=${data.roleCode}&vCode=${data.supplyCode}&supplyCode=${data.supplyCode}&trueName=${data.trueName}&supplyName=${data.supplyName}&userName=${data.userName}&dataFrom=sqm`)
  }
}
  /**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
 const listCheckBoxChange = (rowArr) => {
  data.rowListOfCheck = rowArr
  // if(data.rowListOfCheck.length == 1){
  //   getTaskId()
  // }
};
// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
}
// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
}

const tabsChange = e => {
  for (const key in searchData) {
    searchData[key] = null
  }
  searchData.pageNo = 1
  searchData.pageSize = 10
  searchData.supplyCode = route.query.supplyCode;
  getWarnInfo(true)
}

// 添加 
const addBtn = () => {
  proxy.$router.push({
    name: "rohsReportLibraryAdd",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmAdd',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
    }
  })
}

// 作废 
const voidBtn = (row) => {
  proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('61f53065ee86bd9126ece2a874394bec'),
  confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),callback:(action)=>{
    if (action == 'confirm') {
      // ../api/delROHSReportInfo?id=" + id
      proxy.$http({
            method: 'get',
            url: '/base/newrohs/delRoHSReportInfo?id='+row.id,
          }).then(res=>{
            if(res.data.code == '0' && res.data.data == 'success'){
              proxy.success(h_i18n('3b6eb9c667ec1e3a939d3d2b580e8335'))
              setTimeout(() => {
                getInfo()
              }, 10);
            }
          }).catch(err=>{

          }).finally(()=>{

          })
    }else{

    }
  }
 })
}
// 更新
const upDateBtn = (row) => {
  if(data.roleCode!="S009"){
    proxy.info(h_i18n('de564fc1d38beb5235dc1f4277cd54d8'))
    return
  }
  proxy.$router.push({
    name: "rohsReportLibraryModify",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmModify',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
      id:row.id,
    }
  })
}

// 详情
const toDetail = (row) => {
  proxy.$router.push({
    name: "rohsReportLibraryDetail",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmDetail',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
      id:row.id
    }
  })
}

const getInfo = (flag) => {
  // console.log('1111',searchData)
  if (true == flag) {
    searchData.pageNo = 1;
  }
  data.tableLoading = true;
  proxy.$http({
    url: "/base/newrohs/rohsReportPageInfo",
    method: "post",
    data: {
      ...searchData,
      fixConfig:true,
      mtlNo: searchData.mtlNo || undefined,
      queryFlag:"sqm",
      name:undefined,
      nickName:undefined,
      submitTime:undefined,
    }
  }).then(res=>{
    data.dataOfTable = res.data.data.records
    data.total = res.data.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
  }).finally(()=>{
    data.tableLoading = false
  })
}
const getWarnInfo = (flag) => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  data.tableLoading = true;
  proxy.$http({
    url: "/base/newrohs/rohsReportPageInfo",
    method: "post",
    data: {
      ...searchData,
      mtlNo: searchData.mtlNo || undefined,
      queryFlag:"sqm",
      name:undefined,
      nickName:undefined,
      submitTime:undefined,
      status:2,
      fixConfig:true,
    }
  }).then(res=>{
    data.dataOfTable = res.data.data.records
    data.total = res.data.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
  }).finally(()=>{
    data.tableLoading = false
  })
}

// 导出
const excleBtn = () => {
 
    if (data.total > 5000) {
      proxy.warning(
        { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
        {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => { },
        }
      );
      return;
    }
    data.exportLoading = true;
    proxy.startLoading(h_i18n('df86390ae06f20d33c5ae0c12895d4c9'));
    proxy.httpFile(
      {
        method: "post",
        url: "/base/newrohs/exportRohsReportAll",
        data: {
          ...searchData,
          fixConfig:true,
          mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
          submitTime:undefined,
          pageSize: undefined,
          pageNo: undefined,
          queryFlag:'sqm',
          status:2,
        },
      },
      h_i18n('d1e274c966117803303cfb8b757eacc9')
    ).then(res=>{
      data.exportLoading = false;
    }).catch(err=>{
      data.exportLoading = false;
      proxy.closeLoading()
    })
  
}
// 支持老附件下载
const openFile = (uuid,name) => {
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
  // https://sqm.haier.net/downLoadFileNew?type=5&fileUUID=2024/02/03/284771ef-a758-434c-bf22-157de2839076.jpg
  let url = ''
  if(uuid.includes('http')){
    // url = "/tosqmfordown/"+uuid.split('https://sqm.haier.net/')[1]
    url = "/base/fileDownload/downloadFile?filePath="+uuid.split('https://sqm.haier.net/readFile/')[1]
  }else{
    // let uid = process.env.NODE_ENV === "production" ? "https://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    url = '/base/fileDownload/downLoadFileFtp?type=4&fileUUID='+uuid
  }
  // proxy.startLoading('下载中...')
  proxy.httpFile({
    method: "get",
    url: url,
    headers: {'content-type': 'application/json'},
  }, name)
}

/**
* h-file-upload 删除
*/
const deleteFun = () =>{
  postData.fileUuid = ''
  postData.fileName = ''
  data.fileTemp = {}  
}


onMounted(() => {
  if(route.query.dataFrom != 'sqm'){
    proxy.$router.replace('/404')
    return
  }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    if (route.query) {
      data.supplyCode = route.query.supplyCode;
      searchData.supplyCode = route.query.supplyCode;
      data.supplyName = route.query.supplyName;
      data.trueName = route.query.trueName;
      data.roleCode = route.query.roleCode;
      data.userName = route.query.userName;
      data.activeName = route.query.activeName
    }
    getWarnInfo()
  })

  onActivated(() => {
    if (data.keepalivestatus == 0) {
      // console.log("首次打开");
      data.keepalivestatus ++
    } else {
      proxy.postThisPageHeight();
      // console.log("操作完之后打开");
      getWarnInfo()
    }
  })
  onDeactivated(() => {
    // console.log("keepalive-deactivated页面关闭时触发");
  })
</script>

<style lang="scss">
.rohsReportWarnLibraryList_style{

  .table_button_style{
    padding: 7px 0 !important;
  }
}
.tabs_style {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: transparent;
  .el-tabs__header {
    border-radius: 8px;
    border-bottom: 0px;
  }
  .el-tabs__content {
    padding: 0px;
  }
  #tab-report {
    border-top-left-radius: 15px;
  }
  .el-tabs__item.is-active {
    border-right: 0px;
    border-left: 0px;
  }
}

</style>